import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nl2Br',
    standalone: false
})
export class Nl2BrPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (args[0] === 'reverse') {
      return value.replace(/<br>/gm, '\n');
    }
    return value.replace(/\n/gm, '<br>');
  }
}
